export const WEB_BOOKINGS_PAGE_THEME = 'cyan';

export const WEB_BOOKING_TAB_THEMES = {
    new: 'cyan',
    followup: 'warning',
    processed: 'success',
    all: 'slate',
};

export const WEB_BOOKING_SEARCH_THEMES = {
    firstName: 'indigo',
    lastName: 'purple',
    preferredName: 'pink',
    cellPhone: 'success',
    homePhone: 'cyan',
    email: 'pink',
};

export const WEB_BOOKING_CONTACT_THEMES = {
    'bi-phone': 'success',
    'bi-house': 'cyan',
    'bi-envelope': 'pink',
};

export const WEB_BOOKING_FIELD_THEMES = {
    appointmentType: 'purple',
    reason: 'orange',
    comments: 'info',
    clinicNotes: 'warning',
    doctor: 'indigo',
    firstPreference: 'cyan',
    secondPreference: 'teal',
};

export const WEB_BOOKING_AVATAR_THEMES = [
    'cyan',
    'indigo',
    'purple',
    'success',
    'teal',
    'orange',
    'pink',
    'violet',
];

export const getWebBookingAvatarTheme = (requestId, index = 0) => {
    if (!requestId) {
        return WEB_BOOKING_AVATAR_THEMES[index % WEB_BOOKING_AVATAR_THEMES.length];
    }

    let hash = 0;

    for (let i = 0; i < requestId.length; i += 1) {
        hash = requestId.charCodeAt(i) + ((hash << 5) - hash);
    }

    return WEB_BOOKING_AVATAR_THEMES[Math.abs(hash) % WEB_BOOKING_AVATAR_THEMES.length];
};
